<header>
	<h1>Запрос отменен</h1>
	<app-svg assetsPath="close" (click)="close$.next()"></app-svg>
</header>
<footer>
	<button (click)="close$.next()">Закрыть</button>
</footer>
